import { AbstractMesh } from '@babylonjs/core/Meshes/abstractMesh'
import { TransformNode } from '@babylonjs/core/Meshes/transformNode'
import { replaceFinish } from '../ConfigurationInterpreter'
import Part from './Part'

export default class Nosepad extends Part {
	constructor(parent: TransformNode = null, mirror: boolean = false) {
		super('NOSEPAD', parent, mirror)
	}

	override get filename(): string {
		return this.config.components.NOSEPAD?.design ? `Nosepads/${this.isPrecious ? 'Precious' : 'Titanium'}/${this.config.components.NOSEPAD.design}` : null
	}

	override get isPrecious(): boolean {
		return /^AU750|PT950/.test(this.config.components.NOSEPAD?.color)
	}

	override getMeshMaterialName(mesh: AbstractMesh) {
		if (mesh.name == 'NOSEPAD') {
			return this.config.components.NOSEPAD.color
		} else if (/^NOSEPAD-[A-Z]{2,}$/.test(mesh.name)) {
			return replaceFinish(this.config.components.NOSEPAD.color, mesh.name.split('-')[1])
		} else if (mesh.name == 'DIAMOND') {
			return 'DIAMOND/W'
		}
	}
}
